import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Download, Clock } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function HeroSection() {
  return <section className="pt-12 pb-16 md:pt-20 md:pb-24 px-4 max-w-4xl mx-auto" data-id="element-75">
      <div className="flex flex-col items-center text-center space-y-8" data-id="element-76">
        {/* Stars */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex items-center space-x-1 text-bonus" data-id="element-77">
          {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-78" />)}
          <span className="text-charcoal font-medium ml-2 text-sm" data-id="element-79">
            Más de 10,000 lectoras satisfechas
          </span>
        </motion.div>

        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-charcoal" data-id="element-80">
          Comé rico, liviano y sin malestar con{' '}
          <span className="text-primary underline decoration-primary/40 decoration-4 underline-offset-4" data-id="element-81">
            +365 recetas
          </span>{' '}
          <span className="font-black underline decoration-accent decoration-4 underline-offset-4 text-accent" data-id="element-82">
            sin azúcar ni harina
          </span>{' '}
          para que nunca más tengas que pensar{' '}
          <span className="italic text-accent" data-id="element-83">"¿qué cocino hoy?"</span>
        </motion.h1>

        {/* Product Image — after the title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full max-w-4xl rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-84">
          <motion.img animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/kLvMyvv1eMgPSEAvQYQ8jB/hf_20260411_124437_65fbcc67-c85e-44c2-b9ac-7101d10deeee_(1).png" alt="+365 Recetas Saludables - Sin Azúcar, Sin Harina" className="w-full h-80 md:h-[650px] object-contain" data-id="element-85" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-86"></div>
        </motion.div>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl" data-id="element-87">
          Un sistema para tener resueltas tus{' '}
          <span className="font-bold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-88">
            comidas ricas y saludables
          </span>{' '}
          <span className="font-extrabold bg-yellow-200/60 px-1 rounded" data-id="element-89">
            TODO el año
          </span>
          , desde <span className="font-bold" data-id="element-90">platos del día</span> hasta{' '}
          <span className="font-bold" data-id="element-91">postres</span>, en{' '}
          <span className="font-extrabold underline decoration-accent decoration-2 underline-offset-2" data-id="element-92">
            un solo lugar
          </span>
          .
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-93">
          <CTAButton className="w-full md:w-auto text-lg py-4 px-8" data-id="element-94">
            ACCEDER AHORA POR{' '}
            <PriceDisplay basePriceArs={19990} className="ml-1" data-id="element-95" />
          </CTAButton>
        </motion.div>

        {/* Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="flex flex-wrap justify-center gap-4 pt-2 text-sm text-gray-600 font-medium" data-id="element-96">
          <div className="flex items-center" data-id="element-97">
            <Clock size={16} className="mr-1 text-primary" data-id="element-98" /> Acceso Inmediato
          </div>
          <div className="flex items-center" data-id="element-99">
            <Download size={16} className="mr-1 text-primary" data-id="element-100" /> Descargable
          </div>
          <div className="flex items-center" data-id="element-101">
            <ShieldCheck size={16} className="mr-1 text-primary" data-id="element-102" /> Garantía 7
            Días
          </div>
        </motion.div>
      </div>
    </section>;
}